import { RedoFulfillmentToteGroupSchema } from "@redotech/redo-fulfillment-common/fulfillment-tote-group";
import { locationIdFormat } from "@redotech/redo-inventory-id";
import * as z from "zod";

export const createToteGroup = {
  name: "createToteGroup" as const,
  input: z.object({ name: z.string(), locationId: locationIdFormat.schema }),
  output: RedoFulfillmentToteGroupSchema,
};
